<form [formGroup]="form" class="form-emergency-contact">
  <div class="title-container">
    @if (!emergencyContact) {
      <ion-label class="title">
        {{ 'onboarding.emergency-contact.add-emergency-contact' | transloco }}
      </ion-label>
    } @else {
      <ion-label class="title">
        {{ 'onboarding.emergency-contact.edit-emergency-contact' | transloco }}
      </ion-label>
    }
    <c-button type="secondary" size="small" [iconOnly]="true" [icon]="closeIcon" (action)="close()"></c-button>
  </div>
  <div class="content">
    <div class="text-container form-stack">
      <c-input [label]="'onboarding.emergency-contact.first-name' | transloco" formControlName="firstName"></c-input>
      <c-input [label]="'onboarding.emergency-contact.last-name' | transloco" formControlName="lastName"></c-input>
      <c-phone
        formControlName="phoneNumber"
        [label]="'onboarding.emergency-contact.phone-number' | transloco"
        [helpText]="'onboarding.emergency-contact.phone-number-info' | transloco" />
    </div>
    <div class="button-container">
      <c-button [disabled]="!canSave()" (action)="save()">
        {{ 'onboarding.emergency-contact.save-contact' | transloco }}
      </c-button>
    </div>
  </div>
</form>
